import { render, staticRenderFns } from "./HowToTake.vue?vue&type=template&id=bb5854f2&"
import script from "./HowToTake.vue?vue&type=script&lang=js&"
export * from "./HowToTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports